import { ErrorHandler, AuthErrorHandler } from '../types';
import AxiosErrorHandler from '../api/AxiosErrorHandler';
import api from '../api';

const errorHandler = new AxiosErrorHandler(api);

export function onError(handler: ErrorHandler) {
  errorHandler.onError(handler);
}

export function onAuthError(handler: AuthErrorHandler) {
  errorHandler.onAuthError(handler);
}
